import React from 'react';
import { Request } from '../../services/requestsService';
import { getPriorityColor, getPriorityText, getStatusColor } from '../../utils/taskUtils';

interface TaskDetailHeaderProps {
  task: Request;
  actionLoading: boolean;
  onTakeInWork: () => void;
  onComplete: () => void;
  onBack: () => void;
}

const TaskDetailHeader: React.FC<TaskDetailHeaderProps> = ({
  task,
  actionLoading,
  onTakeInWork,
  onComplete,
  onBack
}) => {
  return (
    <div className="task-detail-header">
      <div className="task-detail-title-section">
        <div className="task-detail-title-row">
          <h1 className="task-detail-title">{task.title}</h1>
          <div className="task-detail-badges">
            <span 
              className="task-detail-priority-badge"
              style={{ backgroundColor: getPriorityColor(task.priority) }}
            >
              {getPriorityText(task.priority)}
            </span>
            <span 
              className="task-detail-status-badge"
              style={{ backgroundColor: getStatusColor(task.status) }}
            >
              {task.status?.name}
            </span>
          </div>
        </div>
      </div>

      <div className="task-detail-actions">
        {task.status?.name === 'Новая' && (
          <button 
            className="task-detail-action-button primary"
            onClick={onTakeInWork}
            disabled={actionLoading}
          >
            {actionLoading ? 'Принимаю...' : 'Принять в работу'}
          </button>
        )}
        <button 
          className="task-detail-action-button secondary"
          onClick={onBack}
        >
          Назад к задачам
        </button>
      </div>
    </div>
  );
};

export default TaskDetailHeader; 